import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { pagedList, sortDirection } from "@/models/pagedList";
import { CustomerInfoModel } from "@/models/customerModels";
import { SisasImportItem } from "@/models/importModels";
@Component({})
export default class importList extends Vue {
  @Prop({ default: "Lista import" })
  title: string;
  @Prop({ default: false })
  isLoading: boolean;

  @Prop({ default: true })
  selectable: boolean;
  
  @Prop({ default: sortDirection.ASC })
  sortDirection: sortDirection;

  @Prop({ default: "" })
  sortField: string;
  
  @Prop({ default: true })
  enableSort: boolean;

  overBtnAggiorna: boolean = false;
  onSelect(imp: SisasImportItem) {
    if (this.selectable) this.$emit("selected", imp);
  }
  onUpdatedata() { 
    this.$emit("updatedata", null);
  }
  @Prop({ default: () => new pagedList<SisasImportItem>() })
  pagedList: pagedList<SisasImportItem>;

  @Prop({ default: () => new Array<SisasImportItem>() })
  list: Array<SisasImportItem>;

  
  headClick(field: string) {
    this.$emit("sort", field);
  }
  getSortCss(field: string): string {
    if (field != this.sortField) return "fas fa-sort text-black-transparent-5";

    return this.sortDirection == sortDirection.ASC
      ? "fas fa-sort-up text-black"
      : "fas fa-sort-down text-black";
  }

  get items(): Array<SisasImportItem> {
    if (this.pagedList == null || this.pagedList.items == null)
      return this.list == null ? [] : this.list;
    return this.pagedList.items;
  }
}
